import React from 'react'
import { NextSeo } from 'next-seo'
import LegalTemplate from '@/src/components/Legal/LegalTemplate'

const LEGAL_CONTENT = `
# **HIPAA Notice of Privacy Practices**



**Last Updated:** January 8, 2021

This notice explains how your health and medical information may be used and disclosed and your rights with respect to such information. 

## **Our Use and Disclosures**

We typically use or share your health and medical information in the following ways:

1. For Health Care. 

We may use and disclose medical information about you to provide you with hearing screening, hearing aid and related services. We may disclose medical information about you to audiologist, physicians, nurses, other health care providers and personnel who are providing or involved in providing health care to you. 

2. For Payment. 

We may use and disclose medical information about you so that we or may bill and collect from you, an insurance company, or a third party for the services we provide. This may also include the disclosure of medical information to obtain prior authorization for treatment and procedures from your insurance plan. 

3. For Operations. 

We may use and disclose medical information about you for our operations. These uses and disclosures are necessary to operate and manage our practice and to promote quality care.

4. Quality Assurance and Utilization Review. 

We may need to use or disclose your medical information to perform a review of the services we provide in order to evaluate whether that the appropriate level of services is received, depending on condition and diagnosis.

5. As Required by Law. 

We will disclose medical information about you when required to do so by federal, state, or local law or regulations.

## **Your Rights**

1. Right to Record 

You can ask to see or get an electronic or paper copy of your medical record and other health information we have about you. We will provide a copy or a summary of your health information, usually within 30 days of your request. We may charge a reasonable, cost-based fee. 

2. Right to Correct or Amend

You can ask us to correct health information about you that you think is incorrect or incomplete. We may deny your request, but we’ll tell you why in writing within 60 days. 

3. Request Confidential Communications 

You can ask us to contact you in a specific way (for example, home or office phone) or to send mail to a different address.

4. Request Restrictions ­

You can ask us not to use or share certain health information for care, payment, or our operations. We are not required to agree to your request, and we may deny your request if it would affect your care.

5. Request Accounting of Disclosure 

You can ask for a list (accounting) of the times we’ve shared your health information for six years prior to the date you ask, whom we shared it with, and why. We will include all the disclosures except for those about care, payment, and health care operations, and certain other disclosures. We will provide one accounting a year for free but will charge a reasonable, cost-based fee if you ask for another one within 12 months. 

6. Right to an Email or Paper Copy of This Notice

You can ask for a paper copy of this notice at any time, even if you have agreed to receive the notice electronically. We will provide you with a paper copy promptly.

To exercise the above rights, please contact us at privacy@hiorka.com.

## **Changes**

We may change the terms of this notice, and the changes will apply to all information we have about you. The new notice will be available upon request and on our website.

## **Complaints**

If you believe that your privacy rights as described in this notice have been violated, you may file a complaint at [privacy@hiorka.com](mailto:privacy@hiorka.com). We will not retaliate against any individual who files a complaint. You may also file a complaint with the Secretary of the Department of Health and Human Services.
`

const HIPAANotice = () => {
  return (
    <>
      <LegalTemplate legalCopy={LEGAL_CONTENT} />
      <NextSeo
        title="Hippa Notice  | Orka - Hear what matters"
        description="This notice explains how your health and medical information may be used and disclosed and your rights with respect to such information."
      />
    </>
  )
}

export default HIPAANotice
